module.exports = __webpack_public_path__ + "static/media/Pattern8.eade8dcf.jpg";